/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type MagicStreamingResponseSubscriptionVariables = Types.Exact<{
  magicEventId: Types.Scalars["MagicEventId"]["input"];
}>;

export type MagicStreamingResponseSubscription = {
  readonly __typename: "Subscription";
  readonly magicStreamingResponse: {
    readonly __typename: "MagicStreamingResponsePayload";
    readonly token: string | null;
    readonly done: boolean;
    readonly error: string | null;
    readonly reset: boolean | null;
    readonly accumulatedResponse: string | null;
    readonly magicEventId: c.MagicEventId;
  };
};

export type CancelMagicRequestMutationVariables = Types.Exact<{
  id: Types.Scalars["MagicEventId"]["input"];
}>;

export type CancelMagicRequestMutation = {
  readonly __typename: "Mutation";
  readonly cancelMagicRequest: string;
};

export type AcceptOrRejectStreamedMagicEventMutationVariables = Types.Exact<{
  id: Types.Scalars["MagicEventId"]["input"];
  userFacingResult: Types.Scalars["String"]["input"];
  acceptType: Types.MagicAcceptType;
}>;

export type AcceptOrRejectStreamedMagicEventMutation = {
  readonly __typename: "Mutation";
  readonly acceptOrRejectStreamedMagicEvent: string;
};

export const MagicStreamingResponseDocument = /*#__PURE__*/ gql`
  subscription MagicStreamingResponse($magicEventId: MagicEventId!) {
    magicStreamingResponse(magicEventId: $magicEventId) {
      token
      done
      error
      reset
      accumulatedResponse
      magicEventId
    }
  }
`;

/**
 * __useMagicStreamingResponseSubscription__
 *
 * To run a query within a React component, call `useMagicStreamingResponseSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMagicStreamingResponseSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMagicStreamingResponseSubscription({
 *   variables: {
 *      magicEventId: // value for 'magicEventId'
 *   },
 * });
 */
export function useMagicStreamingResponseSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    MagicStreamingResponseSubscription,
    MagicStreamingResponseSubscriptionVariables
  > &
    (
      | {
          variables: MagicStreamingResponseSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    MagicStreamingResponseSubscription,
    MagicStreamingResponseSubscriptionVariables
  >(MagicStreamingResponseDocument, options);
}
export type MagicStreamingResponseSubscriptionHookResult = ReturnType<
  typeof useMagicStreamingResponseSubscription
>;
export type MagicStreamingResponseSubscriptionResult =
  Apollo.SubscriptionResult<MagicStreamingResponseSubscription>;
export const CancelMagicRequestDocument = /*#__PURE__*/ gql`
  mutation cancelMagicRequest($id: MagicEventId!) {
    cancelMagicRequest(id: $id)
  }
`;
export type CancelMagicRequestMutationFn = Apollo.MutationFunction<
  CancelMagicRequestMutation,
  CancelMagicRequestMutationVariables
>;

/**
 * __useCancelMagicRequestMutation__
 *
 * To run a mutation, you first call `useCancelMagicRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMagicRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMagicRequestMutation, { data, loading, error }] = useCancelMagicRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelMagicRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelMagicRequestMutation,
    CancelMagicRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelMagicRequestMutation,
    CancelMagicRequestMutationVariables
  >(CancelMagicRequestDocument, options);
}
export type CancelMagicRequestMutationHookResult = ReturnType<
  typeof useCancelMagicRequestMutation
>;
export type CancelMagicRequestMutationResult =
  Apollo.MutationResult<CancelMagicRequestMutation>;
export type CancelMagicRequestMutationOptions = Apollo.BaseMutationOptions<
  CancelMagicRequestMutation,
  CancelMagicRequestMutationVariables
>;
export const AcceptOrRejectStreamedMagicEventDocument = /*#__PURE__*/ gql`
  mutation AcceptOrRejectStreamedMagicEvent(
    $id: MagicEventId!
    $userFacingResult: String!
    $acceptType: MagicAcceptType!
  ) {
    acceptOrRejectStreamedMagicEvent(
      id: $id
      userFacingResult: $userFacingResult
      acceptType: $acceptType
    )
  }
`;
export type AcceptOrRejectStreamedMagicEventMutationFn =
  Apollo.MutationFunction<
    AcceptOrRejectStreamedMagicEventMutation,
    AcceptOrRejectStreamedMagicEventMutationVariables
  >;

/**
 * __useAcceptOrRejectStreamedMagicEventMutation__
 *
 * To run a mutation, you first call `useAcceptOrRejectStreamedMagicEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOrRejectStreamedMagicEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOrRejectStreamedMagicEventMutation, { data, loading, error }] = useAcceptOrRejectStreamedMagicEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userFacingResult: // value for 'userFacingResult'
 *      acceptType: // value for 'acceptType'
 *   },
 * });
 */
export function useAcceptOrRejectStreamedMagicEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptOrRejectStreamedMagicEventMutation,
    AcceptOrRejectStreamedMagicEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptOrRejectStreamedMagicEventMutation,
    AcceptOrRejectStreamedMagicEventMutationVariables
  >(AcceptOrRejectStreamedMagicEventDocument, options);
}
export type AcceptOrRejectStreamedMagicEventMutationHookResult = ReturnType<
  typeof useAcceptOrRejectStreamedMagicEventMutation
>;
export type AcceptOrRejectStreamedMagicEventMutationResult =
  Apollo.MutationResult<AcceptOrRejectStreamedMagicEventMutation>;
export type AcceptOrRejectStreamedMagicEventMutationOptions =
  Apollo.BaseMutationOptions<
    AcceptOrRejectStreamedMagicEventMutation,
    AcceptOrRejectStreamedMagicEventMutationVariables
  >;
